module.exports = __webpack_public_path__ + "659f7019279e735c120395ec1f72ae0c.svg";